import React from 'react'
import {toast} from 'react-toastify'
import {useAuthClient} from '../../utils/use-auth-client'
import {
  FormOverlay,
  FormCard,
  FormTitle,
  FormActions,
  DangerButton,
  SecondaryButton,
  ErrorMessage,
} from '../../screens/features.styled'

function DeleteConfirmModal({assignment, onSuccess, onCancel}) {
  const client = useAuthClient()
  const [isLoading, setIsLoading] = React.useState(false)
  const [error, setError] = React.useState(null)

  const handleRemove = async () => {
    setError(null)
    setIsLoading(true)
    try {
      await client(`feature-flags/${assignment.id}`, {method: 'DELETE'})
      toast.success('Rule removed successfully.')
      onSuccess()
    } catch (err) {
      setError(err.message || 'Failed to remove the rule. Please try again.')
      setIsLoading(false)
    }
  }

  return (
    <FormOverlay onClick={onCancel}>
      <FormCard onClick={e => e.stopPropagation()}>
        <FormTitle>Remove Rule</FormTitle>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            fontSize: '14px',
            color: '#495057',
          }}
        >
          <p style={{margin: 0}}>Are you sure you want to remove this rule?</p>
          <p style={{margin: 0}}>
            <strong>Feature:</strong> {assignment.featureDesc}
          </p>
          <p style={{margin: 0}}>
            <strong>{assignment.entityType}:</strong> {assignment.entityValue}
          </p>
        </div>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <FormActions>
          <SecondaryButton onClick={onCancel} disabled={isLoading}>
            Cancel
          </SecondaryButton>
          <DangerButton
            onClick={handleRemove}
            disabled={isLoading}
            style={{padding: '8px 14px', fontSize: '13px'}}
          >
            {isLoading ? 'Removing...' : 'Remove'}
          </DangerButton>
        </FormActions>
      </FormCard>
    </FormOverlay>
  )
}

export {DeleteConfirmModal}
